export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'ID Tabless',
      placeholder: 'ID intern în sistemul Tabless',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    error: 'Salvarea modificărilor a eșuat',
    success: 'Modificările au fost salvate',
  },
  connected: {
    title: 'Tabless este conectat',
    description: 'Această integrare este configurată.',
  },
};
